// Site genelindeki JSON-LD varlik grafigi.
// Bu modul saf JS'tir (JSX/React yok) — hem React sayfalari hem de build sonrasi
// calisan Node scripti (scripts/prerender.mjs -> src/seo/routeMeta.js) tarafindan
// kullanilir. Tum sayfalar ayni dugumleri buradan uretir; boylece prerender ile
// istemci tarafi cikti arasinda kayma olusmaz.
//
// Grafikte tek bir isletme dugumu vardir: `#organization`. Diger dugumler
// (Person, WebSite, Service) bu dugume `@id` ile referans verir.
//
// NOT: SITE_URL routeMeta.js'ten gelir ve bu iki modul birbirini import eder;
// bu yuzden SITE_URL yalnizca fonksiyon govdelerinde kullanilir (modul govdesinde
// kullanilirsa dairesel import sirasinda TDZ hatasi olusur).

import { SITE_URL } from "./routeMeta.js";

/** Kanonik isletme dugumunun @id degeri. */
export function organizationId() {
    return `${SITE_URL}/#organization`;
}

/** Kanonik kisi (kurucu) dugumunun @id degeri. */
export function personId() {
    return `${SITE_URL}/#person`;
}

/** Isletme ve kurucu icin ortak sosyal profil listesi. */
function sameAs() {
    return [
        "https://www.instagram.com/kchnmuco/",
        "https://www.linkedin.com/in/m%C3%BCcahit-ko%C3%A7han-606660308/",
    ];
}

/** Organization + LocalBusiness birlesik kanonik isletme dugumu. */
export function organizationJsonLd() {
    return {
        "@context": "https://schema.org",
        "@type": ["Organization", "LocalBusiness"],
        "@id": organizationId(),
        "name": "Kochan Productions",
        "alternateName": "Kochan Productions Video Produksiyon",
        "url": SITE_URL,
        "logo": `${SITE_URL}/logonew.png`,
        "image": `${SITE_URL}/logonew.png`,
        "description":
            "Profesyonel video produksiyon, fotograf cekimi ve sosyal medya yonetimi hizmetleri",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Rustempaşa Mah. Hurriyet Sk. No: 3/12 Kat: 2",
            "addressLocality": "Yalova",
            "addressCountry": "TR",
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.6567,
            "longitude": 29.2730,
        },
        "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "opens": "09:00",
            "closes": "18:00",
        },
        "telephone": "+905393541077",
        "email": "mansurpeker7@gmail.com",
        "priceRange": "$$",
        "areaServed": ["Yalova", "Istanbul", "Bursa", "Turkiye"],
        "serviceType": [
            "Video Production",
            "Photography",
            "Social Media Management",
            "Drone Photography",
            "Web Development",
        ],
        "sameAs": sameAs(),
        "founder": { "@id": personId() },
    };
}

/** Kurucu kisi dugumu; isletmeye @id ile baglidir. */
export function personJsonLd() {
    return {
        "@context": "https://schema.org",
        "@type": "Person",
        "@id": personId(),
        "name": "Mucahit Kochan",
        "jobTitle": "Videographer & Social Media Specialist",
        "worksFor": { "@id": organizationId() },
        "url": `${SITE_URL}/about`,
        "image": `${SITE_URL}/images/mucahit-photo.png`,
        "sameAs": sameAs(),
    };
}

/** WebSite dugumu; yayinci olarak isletmeye @id ile baglidir. */
export function websiteJsonLd() {
    return {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
        "name": "Kochan Productions",
        "url": SITE_URL,
        "inLanguage": ["tr", "en", "ar"],
        "publisher": { "@id": organizationId() },
    };
}

/** Hizmet dugumu; saglayici olarak isletmeye @id ile baglidir. */
export function serviceJsonLd({ name, description, path }) {
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        "@id": `${SITE_URL}${path}#service`,
        "name": name,
        "serviceType": name,
        "url": `${SITE_URL}${path}`,
        "description": description,
        "provider": { "@id": organizationId() },
        "areaServed": { "@type": "Country", "name": "Turkey" },
    };
}

/**
 * BreadcrumbList uretir.
 * @param {{ name: string, path: string }[]} items Ana sayfa dahil, sirali kirinti listesi.
 */
export function breadcrumbJsonLd(items) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.name,
            "item": `${SITE_URL}${item.path}`,
        })),
    };
}
